import {TItemId} from 'src/constants';

export enum EVerificationStatus {
  DRAFT = 'DRAFT',
  MANAGER_REVIEW = 'MANAGER_REVIEW',
  NEEDS_CORRECTION = 'NEEDS_CORRECTION',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REJECTED_PERMANENTLY = 'REJECTED_PERMANENTLY',
}

export enum EVerificationError {
  FAILED_TO_SUBMIT = 'FAILED_TO_SUBMIT',
  UNDEFINED_ERROR = 'UNDEFINED_ERROR',
  WRONG_OBJECT_TYPE_WABA = 'WRONG_OBJECT_TYPE_WABA',
  BUSINESS_INFORMATION_IS_STILL_REVIEWING = 'BUSINESS_INFORMATION_IS_STILL_REVIEWING',
}

export type TVerificationStatus = keyof typeof EVerificationStatus;

export type TVerificationRequest = {
  id: number;
  tenantId: TItemId;
  businessPortfolioId: TItemId;
  websiteUrl: string;
  documentFiles: TFile[];
  status: EVerificationStatus;
  error: EVerificationError;
  rejectionReason?: string;
  attemptsCount: number;
  createdAt: string;
  statusAt: string;
};

export const editStatusSet = new Set<TVerificationStatus>([
  'DRAFT',
  'NEEDS_CORRECTION',
  'REJECTED',
]);
export const viewStatusSet = new Set<TVerificationStatus>([
  'MANAGER_REVIEW',
  'PENDING',
  'APPROVED',
  'REJECTED_PERMANENTLY',
]);
